<template #default>
  <div class="ccy-modal">
    <a-modal
      class="page-modal"
      v-model:visible="modalVisible"
      :title="isEdit ? 'Edit ' + localForm.assetClass : 'Add CCY'"
      :style="{ top: '32px', width: '900px' }"
      @ok="handleOk"
      @cancel="handleCancel"
      :confirmLoading="loading"
      destroyOnClose
    >
      <a-form
        ref="addFormRef"
        :model="localForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :rules="rules"
      >
        <a-card class="ccy-card" title="Basics" :bordered="false">
          <a-row :gutter="16">
            <a-col :span="12" v-if="isEdit">
              <a-form-item label="SecurityId">
                <a-input
                  v-model:value="localForm.securityId"
                  :disabled="isEdit"
                />
              </a-form-item>
            </a-col>
            <!--  <a-col :span="12" v-if="isEdit">
              <a-form-item label="ExternalSecurityId">
                <a-input
                  v-model:value="localForm.externalSecurityId"
                  :disabled="isEdit"
                />
              </a-form-item>
            </a-col> -->
            <a-col :span="12">
              <a-form-item label="Exchange">
                <a-select
                  v-model:value="localForm.exchange.exchangeId"
                  allow-clear
                  :show-search="true"
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in exchangeList"
                    :key="item.exchName"
                    :value="item.exchangeId"
                  >
                    {{ item.exchName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="BB_TCM" name="ticker">
                <a-input v-model:value="localForm.ticker" :disabled="isEdit" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Name" name="name">
                <a-input v-model:value="localForm.name" style="width: 100%" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Desc">
                <a-input v-model:value="localForm.desc" style="width: 100%" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Sec Type">
                <SecTypeInput v-model:value="localForm.securityType" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-card>

        <a-card class="ccy-card" title="Quotes" :bordered="false">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="QuoteFactor">
                <a-input-number
                  style="width: 100%"
                  v-model:value="localForm.quoteFactor"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                label="MinorQuoteFactor"
                :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                :wrapperCol="{ span: 16 }"
              >
                <a-input-number
                  style="width: 100%"
                  v-model:value="localForm.minorQuoteFactor"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="DecimalPlaces">
                <a-input-number
                  style="width: 100%"
                  v-model:value="localForm.decimalPlaces"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                label="UsdQuoteCcy"
                :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                :wrapperCol="{ span: 16 }"
              >
                <a-input
                  v-model:value="localForm.usdQuoteCcy"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="InverseQuoted">
                <a-select
                  v-model:value="localForm.inverseQuoted"
                  style="width: 100%"
                >
                  <a-select-option :value="true">Yes</a-select-option>
                  <a-select-option :value="false">No</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-card>

        <a-card class="ccy-card" title="Flags" :bordered="false">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="IsCoin" name="isCoin">
                <a-select v-model:value="localForm.isCoin" style="width: 100%">
                  <a-select-option :value="true">Yes</a-select-option>
                  <a-select-option :value="false">No</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                label="NonDeliverable"
                :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                :wrapperCol="{ span: 16 }"
              >
                <a-select
                  v-model:value="localForm.nonDeliverable"
                  style="width: 100%"
                >
                  <a-select-option :value="true">Yes</a-select-option>
                  <a-select-option :value="false">No</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-card>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, computed, inject, watch } from 'vue'
import { useStore } from 'vuex'
import SecTypeInput from '@/components/SecTypeInput.vue'
import { message } from 'ant-design-vue'
import dayjs from 'dayjs'

const store = useStore()

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
  isEdit: {
    type: Boolean,
    default: false,
  },
  addForm: {
    type: Object,
    required: true,
  },
})

const labelCol = { span: 6, style: { textAlign: 'left' } }
const wrapperCol = { span: 18 }

const exchangeList = inject('exchangeList', ref([]))
const issuerList = inject('issuerList', ref([]))
const security = inject('security')

const addFormRef = ref(null)
const loading = ref(false)
const rules = {
  name: [{ required: true, message: 'Please input name' }],
  ticker: [{ required: true, message: 'Please input BB_TCM' }],
  isCoin: [{ required: true, message: 'Please select IsCoin' }],
}

const countryCurrencyList = computed(() => {
  return store.getters['reference/getCountryCurrencyList'] || []
})

const emit = defineEmits(['update:visible', 'update:security'])

const modalVisible = computed({
  get: () => props.visible,
  set: (val) => emit('update:visible', val),
})

const userName = computed(() => store.getters['auth/getUserName'] || 'Guest')
const localForm = ref(props.addForm)

watch(
  () => props.addForm,
  (newVal) => {
    if (props.visible) {
      localForm.value = newVal
    }
  },
  {
    immediate: true,
  }
)
watch(
  () => localForm.value.priceDivisor,
  (newValue) => {
    if (newValue && props.visible) {
      localForm.value.priceDivisor = newValue
      localForm.value.priceMultiplier = 1 / newValue
    }
  },
  { immediate: true }
)

watch(
  () => localForm.value.issuer?.issuerId,
  (newValue) => {
    if (newValue && props.visible) {
      const selectedIssuer = issuerList.value.find(
        (item) => item.issuerId === newValue
      )
      if (selectedIssuer) {
        localForm.value.issuer = {
          issuerId: selectedIssuer.issuerId,
          externalIssuerId: selectedIssuer.externalIssuerId,
          name: selectedIssuer.name,
          countryOfDomicile: selectedIssuer.countryOfDomicile,
        }
        const selectedCurrency = countryCurrencyList.value.find(
          (item) => item.countryCode === selectedIssuer.countryOfDomicile
        )
        if (selectedCurrency) {
          localForm.value.issueCurrency = selectedCurrency.currencyCode
          localForm.value.pnlCurrency = selectedCurrency.currencyCode
          localForm.value.dividendCurrency = selectedCurrency.currencyCode
        }
      }
    }
  },
  { immediate: true }
)

const filterOption = (input, option) => {
  const key = option?.key ?? option?.value ?? ''
  return String(key).toLowerCase().includes(input.toLowerCase())
}

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.message || fallback

const formatDateTime = (val) =>
  val ? dayjs(val).format('YYYY-MM-DDTHH:mm:ss') : null

const buildPayload = () => {
  const payload = {
    ...localForm.value,
    name: localForm.value.desc,
    exchange: { ...localForm.value.exchange },
    issuer: { ...localForm.value.issuer },
    identifiers: [],
    underlying:
      localForm.value.underlyingTicker && localForm.value.underlying
        ? { ...localForm.value.underlying }
        : null,
    issueDate: formatDateTime(localForm.value.issueDate),
    maturityDate: formatDateTime(localForm.value.maturityDate),
    settleDate: formatDateTime(localForm.value.settleDate),
    lastModifiedOn: dayjs().format('YYYY-MM-DDTHH:mm:ss'),
    lastModifiedBy: userName.value,
  }

  if (payload.ticker) {
    payload.identifiers.push({
      type: 'BB_TCM',
      value: payload.ticker,
    })
  }
  if (payload.isin) {
    payload.identifiers.push({
      type: 'ISIN',
      value: payload.isin,
    })
  }

  const selectedExchange = exchangeList.value.find(
    (item) => item.exchangeId === payload.exchange.exchangeId
  )
  if (selectedExchange) {
    payload.exchange = {
      exchangeId: selectedExchange.exchangeId,
      exchName: selectedExchange.exchName,
      micExchName: selectedExchange.micExchName,
    }
  }

  if (payload.underlyingTicker) {
    const underlyingIdentifiers = [
      {
        type: 'BB_TCM',
        value: payload.underlyingTicker,
        securityId: payload.underlying?.securityId,
        pnlCurrency: payload.underlying?.pnlCurrency,
      },
    ]
    if (!payload.underlying) payload.underlying = {}
    payload.underlying.identifiers = underlyingIdentifiers
    payload.underlying.instrumentClass = 'DUMMY'
  }

  return payload
}

const handleOk = async () => {
  try {
    await addFormRef.value?.validate()
  } catch (error) {
    message.warning(getErrorMessage(error, 'Please complete required fields'))
    return
  }

  loading.value = true
  try {
    const payload = buildPayload()
    if (props.isEdit) {
      await security.updateSec(payload)
      message.success('Security updated successfully')
    } else {
      await security.createSec(payload)
      message.success('Security created successfully')
    }
    modalVisible.value = false
  } catch (error) {
    message.error(
      getErrorMessage(
        error,
        props.isEdit ? 'Failed to update security' : 'Failed to create security'
      )
    )
  } finally {
    loading.value = false
  }
}

const handleCancel = () => {
  modalVisible.value = false
}
</script>

<style scoped>
.ccy-card {
  margin-bottom: 12px;
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(16, 24, 40, 0.06);
}
.ccy-card :deep(.ant-card-head-title) {
  font-weight: 600;
  letter-spacing: 0.2px;
}
.ccy-card :deep(.ant-card-body) {
  padding-top: 8px;
}
</style>
